export default {
    sentimentsContextDashboard: {
        Production: false,
        PreProduction: false,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    errorScreenModals: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: false,
        Development: true,
        Local: true
    },
    extendSessionFeature: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    staffExtendSessionFeature: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    isSiteheaderOn: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    sideMenu: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false,
    },
    isPrimaryButtonOn: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    searchCIDNFeatureFlag: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: false,
        Mock: true,
        Development: false,
        Local: true,
    },
    showUserManagementBanner: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true,
    },
    showMaintenanceBanner: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false,
    },
    covidBannerFlag: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false,
    },
    OneFundBanner: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true,
    },
    noAccountYTT: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true,
    },
    cardEnhacement: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true,
    },
    buttonIntegrations: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    covid19EssestialsBanner: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    covidEssentialServicesBannerFlag: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    yourAccountTeam: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: true,
        Development: false,
        Local: true
    },
    agreedToLatest: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    agreedToAny: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    yourAccountTeamDesc: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    showExistingPromoBanners: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    showStaffReadyOnlyBanner: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    userManagementPromoBanner: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: false,
        Mock: false,
        Development: false,
        Local: false
    },
    sideMenuTrack: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    redesignDataRichTiles: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: false
    }
};
